export const ImportMobileView = () => (
  <div className="mx-4 space-y-3">
    <h1 className="m-auto text-2xl font-bold">Oh no, you are on mobile! 😔</h1>
    <p>
      In order for you to use our Chrome extension to import your club, you have
      to use this site from a desktop computer!
    </p>
  </div>
);
